var moduleMap = {
	"./Navigation": () => {
		return Promise.all([__webpack_require__.e(4561), __webpack_require__.e(6612)]).then(() => (() => ((__webpack_require__(16612)))));
	},
	"./AuthenticatedPage": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(362), __webpack_require__.e(400), __webpack_require__.e(786), __webpack_require__.e(246), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(8663), __webpack_require__.e(8186), __webpack_require__.e(3684), __webpack_require__.e(5929), __webpack_require__.e(5335), __webpack_require__.e(4561), __webpack_require__.e(9667), __webpack_require__.e(8054), __webpack_require__.e(6666), __webpack_require__.e(1107)]).then(() => (() => ((__webpack_require__(53138)))));
	},
	"./usePermissions": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(8186), __webpack_require__.e(5335), __webpack_require__.e(5643)]).then(() => (() => ((__webpack_require__(35643)))));
	},
	"./PrivateRoute": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(8663), __webpack_require__.e(8186), __webpack_require__.e(5335), __webpack_require__.e(4561), __webpack_require__.e(7624)]).then(() => (() => ((__webpack_require__(37624)))));
	},
	"./Permissions": () => {
		return __webpack_require__.e(6072).then(() => (() => ((__webpack_require__(86072)))));
	},
	"./RootState": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(8054), __webpack_require__.e(1252), __webpack_require__.e(2499)]).then(() => (() => ((__webpack_require__(1252)))));
	},
	"./LocaleModule": () => {
		return Promise.all([__webpack_require__.e(8663), __webpack_require__.e(5662)]).then(() => (() => ((__webpack_require__(35662)))));
	},
	"./i18n": () => {
		return Promise.all([__webpack_require__.e(8663), __webpack_require__.e(1805), __webpack_require__.e(951)]).then(() => (() => ((__webpack_require__(40951)))));
	},
	"./KeyboardNavigation": () => {
		return __webpack_require__.e(5225).then(() => (() => ((__webpack_require__(25225)))));
	},
	"./workflowKeys": () => {
		return __webpack_require__.e(5131).then(() => (() => ((__webpack_require__(55131)))));
	},
	"./convertToProperCase": () => {
		return __webpack_require__.e(2022).then(() => (() => ((__webpack_require__(32022)))));
	},
	"./numberFormatter": () => {
		return __webpack_require__.e(7543).then(() => (() => ((__webpack_require__(97543)))));
	},
	"./updateLanguage": () => {
		return Promise.all([__webpack_require__.e(8663), __webpack_require__.e(1805), __webpack_require__.e(4621)]).then(() => (() => ((__webpack_require__(34621)))));
	},
	"./useRefreshProfile": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(9881)]).then(() => (() => ((__webpack_require__(89881)))));
	},
	"./UI": () => {
		return __webpack_require__.e(8186).then(() => (() => ((__webpack_require__(28186)))));
	},
	"./useSysParamAdmin": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(96)]).then(() => (() => ((__webpack_require__(96)))));
	},
	"./useBaseLocation": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(1675)]).then(() => (() => ((__webpack_require__(1675)))));
	},
	"./useUserBranches": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(7086)]).then(() => (() => ((__webpack_require__(17086)))));
	},
	"./PlacesAutoComplete": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(8663), __webpack_require__.e(8186), __webpack_require__.e(1599)]).then(() => (() => ((__webpack_require__(1599)))));
	},
	"./UIThemeProvider": () => {
		return Promise.all([__webpack_require__.e(362), __webpack_require__.e(400), __webpack_require__.e(1527), __webpack_require__.e(3684), __webpack_require__.e(5929), __webpack_require__.e(4372)]).then(() => (() => ((__webpack_require__(60883)))));
	},
	"./setFullURL": () => {
		return __webpack_require__.e(3006).then(() => (() => ((__webpack_require__(93006)))));
	},
	"./websocketService": () => {
		return __webpack_require__.e(7355).then(() => (() => ((__webpack_require__(27355)))));
	},
	"./Icons": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(9667), __webpack_require__.e(4848)]).then(() => (() => ((__webpack_require__(49667)))));
	},
	"./enumFormatter": () => {
		return __webpack_require__.e(9821).then(() => (() => ((__webpack_require__(79821)))));
	},
	"./thousandSeperator": () => {
		return __webpack_require__.e(8851).then(() => (() => ((__webpack_require__(78851)))));
	},
	"./commonDateFormat": () => {
		return Promise.all([__webpack_require__.e(3684), __webpack_require__.e(594)]).then(() => (() => ((__webpack_require__(70594)))));
	},
	"./commonParser": () => {
		return __webpack_require__.e(4674).then(() => (() => ((__webpack_require__(64674)))));
	},
	"./formatLocalDate": () => {
		return Promise.all([__webpack_require__.e(3684), __webpack_require__.e(9380)]).then(() => (() => ((__webpack_require__(49380)))));
	},
	"./DeviceContext": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(3584)]).then(() => (() => ((__webpack_require__(23584)))));
	},
	"./phoneInputValidator": () => {
		return __webpack_require__.e(6824).then(() => (() => ((__webpack_require__(66824)))));
	},
	"./SystemTypeContext": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(1751)]).then(() => (() => ((__webpack_require__(91751)))));
	},
	"./truncateText": () => {
		return __webpack_require__.e(5193).then(() => (() => ((__webpack_require__(85193)))));
	},
	"./BaseCurrencyContext": () => {
		return Promise.all([__webpack_require__.e(6634), __webpack_require__.e(1527), __webpack_require__.e(7220), __webpack_require__.e(9716)]).then(() => (() => ((__webpack_require__(59716)))));
	},
	"./EllipsisTextWrapper": () => {
		return Promise.all([__webpack_require__.e(1527), __webpack_require__.e(8186), __webpack_require__.e(7115)]).then(() => (() => ((__webpack_require__(67115)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});